import { render, staticRenderFns } from "./AppToolbarGhostLogout.vue?vue&type=template&id=1e2fc07a&scoped=true"
import script from "./AppToolbarGhostLogout.vue?vue&type=script&lang=js"
export * from "./AppToolbarGhostLogout.vue?vue&type=script&lang=js"
import style0 from "./AppToolbarGhostLogout.vue?vue&type=style&index=0&id=1e2fc07a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2fc07a",
  null
  
)

export default component.exports